import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useClientContacts, ClientContact } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ClientContact>
      useData={useClientContacts}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
